import { Datacenter, datadogRum } from '@datadog/browser-rum';
import { log } from 'logging/logger';
import { NextWebVitalsMetric } from 'next/app';

/**
 * https://stackoverflow.com/a/57667278/1405803
 * Using Indexable Types fixes this issue:
 *
 * Element implicitly has an 'any' type because expression of type 'string' can't be used to index type
 * '{ FID: string; LCP: string; CLS: string; 'Next.js-hydration': string; 'Next.js-route-change-to-render': string; }'.
 * No index signature with a parameter of type 'string' was found on type
 * '{ FID: string; LCP: string; CLS: string; 'Next.js-hydration': string; 'Next.js-route-change-to-render': string; }'.
 *
 */
const metricsToTrack: { [key: string]: string } = {
  FID: 'FID', // First Input Delay
  LCP: 'LCP', // Largest Contentful Paint
  CLS: 'CLS', // Cumulative Layout Shift
  'Next.js-hydration': 'Nextjs-hydration',
  'Next.js-route-change-to-render': 'Nextjs-route-change-to-render',
};

export const initDatadogRum = () => {
  if (process.env.NODE_ENV !== 'production') {
    log('📊 Datadog will only be available in production');

    return;
  }

  datadogRum.init({
    applicationId: 'b64606bb-eb89-4152-bcac-7423c5dffeb2',
    clientToken: 'pub285535dadadd28b5a86c658dacf221dc',
    datacenter: Datacenter.US,
    resourceSampleRate: 10,
  });

  return function dataDogActions({ name, ...metaData }: NextWebVitalsMetric) {
    if (!Object.keys(metricsToTrack).includes(name)) {
      return;
    }

    const metricName = metricsToTrack[name];

    datadogRum.addUserAction(metricName, {
      [metricName]: Number(metaData.value),
    });
  };
};
